<template>

  <div class="vflex">
    <div class="vflex-row-1">
      <RhevolutJob />
    </div>
  </div>

</template>

<script>
import RhevolutJob from '@/components/RhevolutJob/RhevolutJob'

export default {
  name: 'JobRhevolut',
  components: {
    RhevolutJob
  },
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Job/JobRhevolut/JobRhevolut.vue